import apiConfig from "../../apiConfig";

export const deleteUserArea = async (at, userId, areaId) => {
  const response = await apiConfig.post(
    "API/BASIC/SETTINGS/USERS_AREAS/DEL_USER_AREA",
    {
      User_Id: userId,
      Area_Id: areaId,
    },
    {
      headers: {
        Authorization: `Bearer ${at}`,
      },
    }
  );

  if (response.data.Status) {
    return response.data;
  }

  return [];
};
